import { render } from "./ExtraDienstenView.vue?vue&type=template&id=00322ec2"
import script from "./ExtraDienstenView.vue?vue&type=script&lang=js"
export * from "./ExtraDienstenView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__